import { render, staticRenderFns } from "./ColumnMetricsCard.vue?vue&type=template&id=235cd227&"
import script from "./ColumnMetricsCard.vue?vue&type=script&lang=ts&"
export * from "./ColumnMetricsCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports